// extracted by mini-css-extract-plugin
export default {"title":"Popover-title-GAfA1","body":"Popover-body-nroDV","tooltipBody":"Popover-tooltipBody-VJBHk"};